import { Home } from '@insify/design-system/icons';
import { textXs } from '@insify/design-system/typography';
import React from 'react';
import clsx from 'clsx';
import { BaseLink } from '~components/BaseLink';
import { useBreadcrumbs } from './useBreadcrumbs';
import * as styles from './Breadcrumbs.module.css';

type BreadcrumbsProps = {
  className?: string;
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ className }) => {
  const breadcrumbs = useBreadcrumbs();

  if (!breadcrumbs.length || breadcrumbs.length === 1) return null;

  return (
    <nav className={clsx(styles.nav, className)}>
      {breadcrumbs.map(({ label, path }, index) => (
        <div className={clsx(textXs, styles.segment)} key={path}>
          {index < breadcrumbs.length - 1 ? (
            <BaseLink className={clsx(textXs, styles.link)} href={path} trackingId={path}>
              {index === 0 ? <Home className={styles.home} /> : label}
            </BaseLink>
          ) : (
            <span className={styles.currentPage}>{label}</span>
          )}
        </div>
      ))}
    </nav>
  );
};
